<template>
  <div>
    <div class="page-content">
      <div class="page-box">
        <div class="page-box-content">
          <Row type="flex" justify="space-between">
            <Col>
              <i-form inline>
                <FormItem>
                  <Select v-model="where.status" :placeholder="$t('name.cex_order.status')">
                    <Option v-for="(item, key) in $t('name.cex_order.status_text')" :value="key" :key="key">{{ item }}</Option>
                  </Select>
                </FormItem>
                <FormItem>
                  <Input v-model="where.waybill" :placeholder="$t('name.cex_order.waybill')" style="width: 120px" />
                </FormItem>
                <FormItem>
                  <Input v-model="where.data_name" :placeholder="$t('name.cex_order.data_name')" style="width: 120px" />
                </FormItem>
                <FormItem>
                  <Input v-model="where.data_phone" :placeholder="$t('name.cex_order.data_phone')" style="width: 120px" />
                </FormItem>
                <FormItem>
                  <Cascader :data="cex" @on-change="(value) => { this.where.name = value.join('/'); }" :placeholder="$t('name.cex_order.name')" style="width: 200px" />
                </FormItem>
                <FormItem>
                  <DatePicker type="daterange" placement="bottom-end" :placeholder="$t('name.cex_order.created_at')" v-model="daterange" @on-change="onTime" :clearable="false" />
                </FormItem>
                <FormItem>
                  <Checkbox v-model="where.track_breakdown" :true-value="1" :false-value="0">{{ $t('name.cex_order.track_breakdown') }}</Checkbox>
                </FormItem>
                <FormItem>
                  <Button type="primary" icon="md-search" @click="search">{{ $t('name.search') }}</Button>
                </FormItem>
              </i-form>
            </Col>
            <Col>
              <Button type="success" icon="md-apps" @click="onExcel(false)">{{ $t('name.excel') }}</Button> &nbsp;&nbsp;
              <Button type="primary" icon="md-flag" @click="$refs.query.open()">{{ $t('name.cex.query.title') }}</Button>
              <Query ref="query" />
            </Col>
          </Row>
          <Table ref="table" :list="list" @get="getData" />
          <div class="page-box-content" style="text-align:center">
            <Page 
              :current.sync="where.page" 
              :total="total" 
              :page-size="size" 
              @on-change="getData" 
              show-total 
              show-elevator 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from './table'
import Query from '../cex/query'
import { user } from '@/api/cex_order';
import { get } from '@/api/cex';

export default {
  components:{
    Table,
    Query
  },
  data() {
    return {
      cex: [],
      list: [],
      total: 0,
      size: 0,
      where: {
        page: 1,
        name: null,
        data_name: null,
        data_phone: null,
        status: null,
        time: null,
        track_breakdown: 0
      },
      // 日期选择
      daterange: []
    }
  },
  created() {
    this.getData()
    // 获取Cex
    get().then(res => {
      // 整理线路
      const handle = (data) => {
        return data.map(item => {
          return {
            value: item.name,
            label: item.name,
            children: item.cex ? handle(item.cex) : [],
            ...item,
          }
        })
      }
      
      this.cex = handle(res)
    })
  },
  methods: {
    // 获取最新配置
    getData() {
      user(this.where).then(res => {
        this.list = res.data
        this.where.page = res.current_page
        this.total = res.total
        this.size = res.per_page
      })
    },
    
    // 搜索
    search() {
      this.where.page = 1
      this.getData()
    },
    
    // 选择时间
    onTime() {
      this.where.time = [this.daterange[0].getTime() / 1000, this.daterange[1].getTime() / 1000 + (60 * 60 * 24)]
    },
    
    // 导出表格
    onExcel() {
      // 检查时间
      if(!this.where.time) {
        return this.$Message.warning(this.$t('message.time'))
      }

      // 条件 + 全部条件
      let where = Object.assign({ all: 1 }, this.where)

      // 全部数据
      user(where).then(data => {
        this.$refs.table.excel(data)
      })
    }
  },
};
</script>